import {
  REPORT_FWPROGRESS_FETCH,
  REPORT_FWPROGRESS_FETCH_RESET,
  REPORT_FWPROGRESS_FETCH_SUCCESS,
  REPORT_QCDATA_FETCH,
  REPORT_QCDATA_FETCH_RESET,
  REPORT_QCDATA_FETCH_SUCCESS,
  REPORT_SUMMARY_OVERVIEW_FETCH,
  REPORT_SUMMARY_OVERVIEW_FETCH_RESET,
  REPORT_SUMMARY_OVERVIEW_FETCH_SUCCESS,
  REPORT_SUMMARY_FACTOR_FETCH,
  REPORT_SUMMARY_FACTOR_FETCH_RESET,
  REPORT_SUMMARY_FACTOR_FETCH_SUCCESS,
  REPORT_SUMMARY_CARMODEL_FETCH,
  REPORT_SUMMARY_CARMODEL_FETCH_RESET,
  REPORT_SUMMARY_CARMODEL_FETCH_SUCCESS,
  REPORT_LATEST_FETCH,
  REPORT_LATEST_FETCH_RESET,
  REPORT_LATEST_FETCH_SUCCESS,
  REPORT_SUMMARY_OVERVIEW_DEFAULT_FETCH,
  REPORT_SUMMARY_OVERVIEW_DEFAULT_FETCH_RESET,
  REPORT_SUMMARY_OVERVIEW_DEFAULT_FETCH_SUCCESS,
  REPORT_CUSTOMER_VOICE_FETCH,
  REPORT_CUSTOMER_VOICE_FETCH_RESET,
  REPORT_CUSTOMER_VOICE_FETCH_SUCCESS,
  REPORT_RANKING_FETCH,
  REPORT_RANKING_FETCH_RESET,
  REPORT_RANKING_FETCH_SUCCESS,
} from './types';

export const reportFwProgressFetch = payload => {
  return {
    type: REPORT_FWPROGRESS_FETCH,
    payload: payload,
  };
};

export const reportFwProgressFetchSuccess = payload => {
  return {
    type: REPORT_FWPROGRESS_FETCH_SUCCESS,
    payload: payload,
  };
};

export const reportFwProgressFetchReset = () => {
  return {
    type: REPORT_FWPROGRESS_FETCH_RESET,
  };
};

export const reportQCDataFetch = payload => {
  return {
    type: REPORT_QCDATA_FETCH,
    payload: payload,
  };
};

export const reportQCDataFetchSuccess = payload => {
  return {
    type: REPORT_QCDATA_FETCH_SUCCESS,
    payload: payload,
  };
};

export const reportQCDataFetchReset = () => {
  return {
    type: REPORT_QCDATA_FETCH_RESET,
  };
};

export const reportSummaryOverviewFetch = payload => {
  return {
    type: REPORT_SUMMARY_OVERVIEW_FETCH,
    payload: payload,
  };
};

export const reportSummaryOverviewFetchSuccess = payload => {
  return {
    type: REPORT_SUMMARY_OVERVIEW_FETCH_SUCCESS,
    payload: payload,
  };
};

export const reportSummaryOverviewFetchReset = () => {
  return {
    type: REPORT_SUMMARY_OVERVIEW_FETCH_RESET,
  };
};

export const reportSummaryFactorFetch = payload => {
  return {
    type: REPORT_SUMMARY_FACTOR_FETCH,
    payload: payload,
  };
};

export const reportSummaryFactorFetchSuccess = payload => {
  return {
    type: REPORT_SUMMARY_FACTOR_FETCH_SUCCESS,
    payload: payload,
  };
};

export const reportSummaryFactorFetchReset = () => {
  return {
    type: REPORT_SUMMARY_FACTOR_FETCH_RESET,
  };
};

export const reportSummaryCarModelFetch = payload => {
  return {
    type: REPORT_SUMMARY_CARMODEL_FETCH,
    payload: payload,
  };
};

export const reportSummaryCarModelFetchSuccess = payload => {
  return {
    type: REPORT_SUMMARY_CARMODEL_FETCH_SUCCESS,
    payload: payload,
  };
};

export const reportSummaryCarModelFetchReset = () => {
  return {
    type: REPORT_SUMMARY_CARMODEL_FETCH_RESET,
  };
};

export const reportLatestFetch = payload => {
  return {
    type: REPORT_LATEST_FETCH,
    payload: payload,
  };
};

export const reportLatestFetchSuccess = payload => {
  return {
    type: REPORT_LATEST_FETCH_SUCCESS,
    payload: payload,
  };
};

export const reportLatestFetchReset = () => {
  return {
    type: REPORT_LATEST_FETCH_RESET,
  };
};

export const reportSummaryOverviewDefaultFetch = payload => {
  return {
    type: REPORT_SUMMARY_OVERVIEW_DEFAULT_FETCH,
    payload: payload,
  };
};

export const reportSummaryOverviewDefaultFetchSuccess = payload => {
  return {
    type: REPORT_SUMMARY_OVERVIEW_DEFAULT_FETCH_SUCCESS,
    payload: payload,
  };
};

export const reportSummaryOverviewDefaultFetchReset = () => {
  return {
    type: REPORT_SUMMARY_OVERVIEW_DEFAULT_FETCH_RESET,
  };
};

export const reportCustomerVoiceFetch = payload => {
  return {
    type: REPORT_CUSTOMER_VOICE_FETCH,
    payload: payload,
  };
};

export const reportCustomerVoiceFetchSuccess = payload => {
  return {
    type: REPORT_CUSTOMER_VOICE_FETCH_SUCCESS,
    payload: payload,
  };
};

export const reportCustomerVoiceFetchReset = () => {
  return {
    type: REPORT_CUSTOMER_VOICE_FETCH_RESET,
  };
};

export const reportRankingFetch = payload => {
  return {
    type: REPORT_RANKING_FETCH,
    payload: payload,
  };
};

export const reportRankingFetchSuccess = payload => {
  return {
    type: REPORT_RANKING_FETCH_SUCCESS,
    payload: payload,
  };
};

export const reportRankingFetchReset = () => {
  return {
    type: REPORT_RANKING_FETCH_RESET,
  };
};
